import { createSlice } from "@reduxjs/toolkit";

const tcodeAccessSlice = createSlice({
  name: "tcodeAccess",
  initialState: {
    tcodeAccessible: undefined,
    tcodeRole: null,
    tcodeUserException: null, // { user_id, level, tcodes[] } or null
  },
  reducers: {
    setTcodeAccess: (_, action) => ({
      tcodeAccessible: !!action.payload.tcode_access,
      tcodeRole: action.payload.tcode_role || null,
      tcodeUserException: action.payload.tcode_user_exceptions || null,
    }),
    resetTcodeAccess: () => ({
      tcodeAccessible: undefined,
      tcodeRole: null,
      tcodeUserException: null,
    }),
  },
});

export const { setTcodeAccess, resetTcodeAccess } = tcodeAccessSlice.actions;
export default tcodeAccessSlice.reducer;
